import { Link, Typography } from '@one-thd/sui-atomic-components';
import React, { useState } from 'react';
export var Breadcrumbs = function (_a) {
    var routes = _a.routes, isMobile = _a.isMobile;
    var _b = useState(false), expandCrumbs = _b[0], setExpandCrumbs = _b[1];
    var _c = useState(false), breadLoaded = _c[0], setBreadLoaded = _c[1];
    setTimeout(function () {
        setBreadLoaded(true);
    }, 1000);
    var generatePaths = function () {
        return routes.map(function (_a, index) {
            var path = _a.path, label = _a.label;
            return (React.createElement("div", { key: index, className: "sui-flex sui-gap-4" }, routes.length - 1 !== index ? (React.createElement(React.Fragment, null,
                React.createElement(Link, { href: path, color: "subtle", variant: "body-base" }, label),
                routes.length !== index && (React.createElement("div", { className: "sui-mr-4" },
                    React.createElement(Typography, { color: "subtle", variant: "body-base" },
                        ' ',
                        "/",
                        ' '))))) : (React.createElement(Typography, { color: "subtle", variant: "body-base" }, label))));
        });
    };
    var renderMobile = function () {
        var _a, _b, _c;
        return expandCrumbs ? (generatePaths()) : (React.createElement("div", { className: "sui-flex" },
            React.createElement("div", { className: "sui-cursor-pointer sui-mr-4" },
                React.createElement(Typography, { color: "subtle", decoration: "underline", onClick: function () { return setExpandCrumbs(true); }, variant: "body-base" }, "...")),
            React.createElement("div", { className: "sui-mr-2" },
                React.createElement(Typography, { color: "subtle", variant: "body-base" }, "/")),
            React.createElement(Typography, { color: "subtle", variant: "body-base" }, "\u00A0"),
            React.createElement("div", { className: "sui-mr-4" },
                React.createElement(Link, { href: (_a = routes === null || routes === void 0 ? void 0 : routes.at(-2)) === null || _a === void 0 ? void 0 : _a.path, color: "subtle", variant: "body-base" }, (_b = routes === null || routes === void 0 ? void 0 : routes.at(-2)) === null || _b === void 0 ? void 0 : _b.label)),
            React.createElement("div", { className: "sui-mr-4" },
                React.createElement(Typography, { color: "subtle", variant: "body-base" }, "/")),
            React.createElement(Typography, { color: "subtle", variant: "body-base" }, (_c = routes === null || routes === void 0 ? void 0 : routes.at(-1)) === null || _c === void 0 ? void 0 : _c.label)));
    };
    return (React.createElement("div", { className: "sui-flex ".concat(isMobile && expandCrumbs
            ? 'sui-overflow-x-scroll sui-whitespace-nowrap sui-pb-1'
            : 'sui-whitespace-nowrap'), "data-testid": "breadcrumbs" }, breadLoaded && (isMobile ? renderMobile() : generatePaths())));
};
